import { render, staticRenderFns } from "./InternalFileManagerTree.vue?vue&type=template&id=545de248&"
import script from "./InternalFileManagerTree.vue?vue&type=script&lang=ts&"
export * from "./InternalFileManagerTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports